// extracted by mini-css-extract-plugin
module.exports = {"TableTitle":"TableTitle_TableTitle__1fieq","arrows":"TableTitle_arrows__1LOS5","title":"TableTitle_title__2fnHV"};